export const EQUIPMENT_MALFUNCTION_TYPES = [
  'Control Station',
  'Electrical System',
  'Fuel System',
  'Navigation System',
  'Onboard Flight Control System',
  'Power Plant',
  'Lost Link Events'
] as const;

export const ACCIDENT_TYPES = [
  'Fatal Injury',
  'Serious Injury - Hospitalization',
  'Serious Injury - Fracture of Bone',
  'Serious Injury - Severe Hemorrhage',
  'Serious Injury - Nerve Muscle or Tendon',
  'Serious Injury - Internal Organs',
  'Serious Injury - Burns',
  'Serious Injury - Other'
] as const;

export const UA_LOSS_TYPES = [
  'Substantial Damage to Aircraft',
  'Substantial Damage to Property'
] as const;

export const RATE_UNIT_OPTIONS = [
  { value: 'oz/ac', label: 'oz/ac' },
  { value: 'pt/ac', label: 'pt/ac' },
  { value: 'qt/ac', label: 'qt/ac' },
  { value: 'gal/ac', label: 'gal/ac' },
  { value: 'lb/ac', label: 'lb/ac' },
] as const;

export const PPE_OPTIONS = [
  { value: 'gloves', label: 'Gloves' },
  { value: 'coveralls', label: 'Coveralls' },
  { value: 'apron', label: 'Apron' },
  { value: 'faceShield', label: 'Face Shield' },
  { value: 'goggles', label: 'Goggles' },
  { value: 'respirator', label: 'Respirator' },
  { value: 'rubberBoots', label: 'Rubber Boots' }
] as const;

export const APPLICATION_TYPE_OPTIONS = [
  { value: 'herbicide', label: 'Herbicide' },
  { value: 'pesticide', label: 'Pesticide' },
  { value: 'fungicide', label: 'Fungicide' },
  { value: 'fertilizer', label: 'Fertilizer' },
  { value: 'other', label: 'Other' }
] as const;
